import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';

import { authActions } from '../../redux/slices/authSlice';
import { useAppDisPatch } from '../../redux/store';
import { ACCOUNT, HEALTH_SIGNIN } from '../../routes/routeConstants';

const useOnLogout = () => {
  const navigate = useNavigate();
  const dispatch = useAppDisPatch();

  const logoutHealth = () => {
    const onSuccess = () => {
      toast.success('Signed Out!', {
        duration: 3000,
      });
      localStorage.removeItem('authData');
      dispatch(authActions.reset());
      navigate(`/${ACCOUNT}/${HEALTH_SIGNIN}`);
    };

    onSuccess();
  };

  return {
    logoutHealth,
  };
};

export default useOnLogout;
